@if (!item.hidden && (isGrantedRole && (!item.isCoordenador || (item.isCoordenador && isCoordenador)))) {
  <!-- item.url -->
  @if (item.url && !item.externalUrl && !item.function) {
    <a class="nav-link" [ngClass]="item.classes"
      [routerLink]="[item.url]" [routerLinkActive]="['active', 'bg-primary', 'text-on-primary']"
      [routerLinkActiveOptions]="{exact: item.exactMatch || false}"
      [target]="item.openInNewTab ? '_blank' : '_self'"
      (click)="onItemClick()"
      role="menuitem"
      [attr.aria-label]="item.title"
      [attr.aria-current]="isActive ? 'page' : null">
      <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </a>
  }
  <!-- item.externalUrl -->
  @if (item.url && item.externalUrl && !item.function) {
    <a class="nav-link" [ngClass]="item.classes"
      [href]="item.url" [target]="item.openInNewTab ? '_blank' : '_self'"
      (click)="onItemClick()"
      role="menuitem"
      [attr.aria-label]="item.title + (item.openInNewTab ? ' (abre em nova aba)' : '')">
      <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </a>
  }
  <!-- item.function -->
  @if (!item.url && item.function) {
    <span class="nav-link" [ngClass]="item.classes"
      (click)="item.function(); onItemClick()"
      role="menuitem"
      tabindex="0"
      (keydown.enter)="item.function(); onItemClick()"
      [attr.aria-label]="item.title">
      <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </span>
  }
  <!-- item.url && item.function -->
  @if (item.url && !item.externalUrl && item.function) {
    <a class="nav-link" [ngClass]="item.classes"
      (click)="item.function(); onItemClick()"
      [routerLink]="[item.url]" [routerLinkActive]="['active', 'bg-primary', 'text-on-primary']"
      [routerLinkActiveOptions]="{exact: item.exactMatch || false}"
      [target]="item.openInNewTab ? '_blank' : '_self'"
      role="menuitem"
      [attr.aria-label]="item.title">
      <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </a>
  }
  <!-- item.externalUrl && item.function -->
  @if (item.url && item.externalUrl && item.function) {
    <a class="nav-link" [ngClass]="item.classes"
      (click)="item.function(); onItemClick()"
      [href]="item.url" [target]="item.openInNewTab ? '_blank' : '_self'"
      role="menuitem"
      [attr.aria-label]="item.title + (item.openInNewTab ? ' (abre em nova aba)' : '')">
      <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </a>
  }
  <ng-template #itemContent>
    @if (item.icon) {
      <mat-icon class="nav-link-icon" aria-hidden="true">{{item.icon}}</mat-icon>
    }
    <span class="nav-link-title" [translate]="item.translate" [matTooltip]="item.title.length > 25 ? item.title : ''">{{item.title}}</span>
    @if (item.badge) {
      <span class="nav-link-badge" [translate]="item.badge.translate"
        [ngStyle]="{'background-color': item.badge.bg,'color': item.badge.fg}"
        [attr.aria-label]="item.badge.title + ' itens'">
        {{item.badge.title}}
      </span>
    }
    @if (item.badgeCompartilhada) {
      <span class="nav-link-badge-shares" matTooltip="Compartilhadas"
        [ngStyle]="{'background-color': item.badgeCompartilhada.badge.bg,'color': item.badgeCompartilhada.badge.fg}"
        [attr.aria-label]="item.badgeCompartilhada.badge.title + ' compartilhadas'">
        {{item.badgeCompartilhada.badge.title}}
      </span>
    }
  </ng-template>
}
